import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=3019ecd8&scoped=true&"
import script from "./SidebarComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarComponent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarComponent.vue?vue&type=style&index=0&id=3019ecd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019ecd8",
  null
  
)

export default component.exports